import { Autocomplete } from "@mui/material";
import CancelButton from "Common/Components/Buttons/CancelButton";
import { DeleteButton } from "Common/Components/Buttons/DeleteButton";
import PrimarySubmitButton from "Common/Components/Buttons/PrimarySubmitButton";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import { autocompleteDropdownStyles } from "Constants/Style";
import {
  Col,
  Form,
  Row
} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { BsEnvelope, BsTelephone } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

interface AddSupplierProps {
  contactPersonTableFormik: any;
  supplierDetailsFormik: any;
}

const SupplierDetails: React.FC<AddSupplierProps> = ({ contactPersonTableFormik, supplierDetailsFormik }) => {
  const navigate = useNavigate();

  const handleDelete = (index: number) => {
    const updated = supplierDetailsFormik?.values?.contacts.filter((_: any, i: number) => i !== index);
    supplierDetailsFormik?.setFieldValue('contacts', updated);
  };

  // ---------------------- UI ---------------------- //
  return (
    <>
      <Form onSubmit={supplierDetailsFormik.handleSubmit}>
        <Row className="mb-4 gy-3">
          <Col xs={12} md={4}>
            <Form.Label className="fw-semibold">
              Supplier Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Enter Supplier Name"
              id="supplier_name"
              name="supplier_name"
              value={supplierDetailsFormik.values.supplier_name}
              onChange={supplierDetailsFormik.handleChange}
              onBlur={supplierDetailsFormik.handleBlur}
              isInvalid={!!(supplierDetailsFormik.touched.supplier_name && supplierDetailsFormik.errors.supplier_name)}
            />
            <Form.Control.Feedback type="invalid">
              {supplierDetailsFormik.errors.supplier_name}
            </Form.Control.Feedback>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label className="fw-semibold">
              Supplier Type <span className="text-danger">*</span>
            </Form.Label>
            <Autocomplete
              options={["Local", "Import"]}
              getOptionLabel={(option: any) => option}
              value={supplierDetailsFormik?.values?.supplier_type}
              onChange={(event, val) =>
                supplierDetailsFormik.setFieldValue("supplier_type", val || "")
              }
              onBlur={() => supplierDetailsFormik.setFieldTouched("supplier_type", true)}
              ListboxProps={autocompleteDropdownStyles.ListboxProps}
              renderOption={(props, option) =>
                autocompleteDropdownStyles.renderOption(
                  props,
                  option,
                  (opt: any) => opt,
                )
              }
              renderInput={(params) => (
                <BootstrapTextField
                  {...params}
                  placeholder="Select Supplier Type"
                  id="supplier_type"
                  name="supplier_type"
                  error={
                    supplierDetailsFormik.touched.supplier_type &&
                    Boolean(supplierDetailsFormik.errors.supplier_type)
                  }
                  helperText={
                    supplierDetailsFormik.touched.supplier_type &&
                    supplierDetailsFormik.errors.supplier_type
                  }
                  sx={{
                    ...autocompleteDropdownStyles.inputSx,
                  }}
                  fullWidth
                  size="small"
                />
              )}
            />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label className="fw-semibold">
              On Boarding Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              id="on_boarding_date"
              name="on_boarding_date"
              value={supplierDetailsFormik.values.on_boarding_date}
              onChange={supplierDetailsFormik.handleChange}
              onBlur={supplierDetailsFormik.handleBlur}
              isInvalid={
                !!(
                  supplierDetailsFormik.touched.on_boarding_date &&
                  supplierDetailsFormik.errors.on_boarding_date
                )
              }
            />
            <Form.Control.Feedback type="invalid">
              {supplierDetailsFormik.errors.on_boarding_date}
            </Form.Control.Feedback>
          </Col>

          <Col xs={12} md={4}>
            <Form.Label className="fw-semibold">
              Company Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Enter Company Email"
              id="email"
              name="email"
              value={supplierDetailsFormik.values.email}
              onChange={supplierDetailsFormik.handleChange}
              onBlur={supplierDetailsFormik.handleBlur}
              isInvalid={
                !!(
                  supplierDetailsFormik.touched.email &&
                  supplierDetailsFormik.errors.email
                )
              }
            />
            <Form.Control.Feedback type="invalid">
              {supplierDetailsFormik.errors.email}
            </Form.Control.Feedback>
          </Col>

          <Col xs={12} md={4}>
            <Form.Label className="fw-semibold">
              Phone No. <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              id="phone_number"
              name="phone_number"
              placeholder="Enter Phone No."
              value={supplierDetailsFormik.values.phone_number}
              onChange={(e) => {
                const value = e.target.value.replace(/[^\d+\s()-]/g, "");
                supplierDetailsFormik.setFieldValue("phone_number", value);
              }}
              onBlur={supplierDetailsFormik.handleBlur}
              isInvalid={
                !!(
                  supplierDetailsFormik.touched.phone_number &&
                  supplierDetailsFormik.errors.phone_number
                )
              }
            />
            <Form.Control.Feedback type="invalid">
              {supplierDetailsFormik.errors.phone_number}
            </Form.Control.Feedback>
          </Col>
        </Row>

        {/* ---------------------- Contact Persons ---------------------- */}
        <h5 className="fw-bold">Basic Contact Details</h5>
        <Row className="mb-3 gy-3">
          <Col xs={12} md={4}>
            <Form.Group controlId="name" className="mt-1">
              <Form.Label className="fw-semibold">
                Contact Person <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="name"
                name="name"
                placeholder="Enter Name"
                value={contactPersonTableFormik.values.name}
                onChange={contactPersonTableFormik.handleChange}
                onBlur={contactPersonTableFormik.handleBlur}
                isInvalid={
                  !!(
                    contactPersonTableFormik.touched.name &&
                    contactPersonTableFormik.errors.name
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {contactPersonTableFormik.errors.name}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group controlId="designation" className="mb-0">
              <Form.Label className="fw-semibold">
                Designation <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="designation"
                name="designation"
                placeholder="Enter Designation"
                value={contactPersonTableFormik.values.designation}
                onChange={contactPersonTableFormik.handleChange}
                onBlur={contactPersonTableFormik.handleBlur}
                isInvalid={
                  !!(
                    contactPersonTableFormik.touched.designation &&
                    contactPersonTableFormik.errors.designation
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {contactPersonTableFormik.errors.designation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group controlId="email" className="mb-0">
              <Form.Label className="fw-semibold">
                Contact Person Email <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="email"
                name="email"
                placeholder="Enter Email"
                value={contactPersonTableFormik.values.email}
                onChange={contactPersonTableFormik.handleChange}
                onBlur={contactPersonTableFormik.handleBlur}
                isInvalid={
                  !!(
                    contactPersonTableFormik.touched.email &&
                    contactPersonTableFormik.errors.email
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {contactPersonTableFormik.errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group controlId="phone_number" className="mb-0">
              <Form.Label className="fw-semibold">
                Contact Person Phone No. <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                id="phone_number"
                name="phone_number"
                placeholder="Enter Phone No."
                value={contactPersonTableFormik.values.phone_number}
                // onChange={contactPersonTableFormik.handleChange}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^\d+\s()-]/g, "");
                  contactPersonTableFormik.setFieldValue("phone_number", value);
                }}
                onBlur={contactPersonTableFormik.handleBlur}
                isInvalid={
                  !!(
                    contactPersonTableFormik.touched.phone_number &&
                    contactPersonTableFormik.errors.phone_number
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {contactPersonTableFormik.errors.phone_number}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <CancelButton
          onClick={() => contactPersonTableFormik.handleSubmit()}
          showConfirmation={false}
          label="+ Add Contact Details"
        />
        {supplierDetailsFormik?.values.contacts.length > 0 && (
          <div className="mt-4">
            <h6 className="fw-bold mb-3">Added Contact Details</h6>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              {supplierDetailsFormik?.values?.contacts?.map(
                (contact: any, index: number) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "12px 16px",
                      backgroundColor: "#f9f9f9",
                      borderRadius: "4px",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.875rem",
                          color: "#333",
                          fontWeight: "600",
                          marginBottom: "4px",
                        }}
                      >
                        <strong>Contact {index + 1}</strong>
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.875rem",
                          color: "#333",
                          marginBottom: "4px",
                        }}
                      >
                        {contact.name}{" "}
                        {contact.designation && (
                          <span style={{ color: "#666", marginLeft: "0px" }}>
                            ({contact.designation})
                          </span>
                        )}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          marginBottom: "4px",
                        }}
                      >
                        <BsTelephone size={14} style={{ color: "#666" }} />
                        <span style={{ fontSize: "0.875rem", color: "#666" }}>
                          {contact?.phone_number}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <BsEnvelope size={14} style={{ color: "#666" }} />
                        <span style={{ fontSize: "0.875rem", color: "#666" }}>
                          {contact?.email}
                        </span>
                      </div>
                    </div>
                    <DeleteButton onClick={() => handleDelete(index)} />
                  </div>
                ),
              )}
            </div>
          </div>
        )}

        {/* ---------------------- Action Buttons ---------------------- */}
        <div className="d-flex flex-column flex-md-row justify-content-center gap-3 mt-3">
          <CancelButton
            onClick={() => navigate("/master/supplier")}
            showConfirmation={true}
          />
          <PrimarySubmitButton label="Next" />
        </div>
      </Form>
    </>
  );
};

export default SupplierDetails;
